import React, { useEffect } from "react";
import { Desktop } from "../containers/common";
import {
  ProvideNumber,
  UserInfoScreen,
  VerifyOTP,
  ProfileScreen,
  ThemeSelectorScreen,
  PulseHome,
} from "../screens/subscriber/";

// hooks
import { useAuth } from "../hooks/";

const Login = () => {
  const { loginStage, setLoginState, checkLogin } = useAuth();

  useEffect(() => {
    checkLogin();
  }, [loginStage]);

  return (
    <Desktop phonebg={"white"}>
      {loginStage === "LoginScreen" && (
        <ProvideNumber setLoginState={setLoginState} />
      )}
      {/* <PulseHome setLoginState={setLoginState} /> */}
      {loginStage === "OTPScreen" && (
        <VerifyOTP setLoginState={setLoginState} />
      )}
      {loginStage === "UserInfoScreen" && (
        <UserInfoScreen setLoginState={setLoginState} />
      )}
    </Desktop>
  );
};

export default Login;
